import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiLearningUnitTeacher, ApiLessonInstance, ApiPersonalProfile,} from 'src/app/col/model/rest-model';
import {environment} from 'src/environments/environment';
import {ColNativeServiceApi} from '../col-native-api';

@Injectable({
  providedIn: 'root',
})
export class WebColNativeServiceApi implements ColNativeServiceApi {
  constructor(private http: HttpClient) {
  }

  private getUrlLessonTeacher(path: string, teacherId?: number) {
    return (
      `${environment.lessonEndpoint}/teacher` +
       (teacherId ? `/${teacherId}` : '') +
       path
    );
  }

  public createVideoClassroom(
    teacherId: number,
    lessonId: number
  ): Observable<ApiLessonInstance<ApiPersonalProfile, ApiLearningUnitTeacher>> {
    return this.http.put<ApiLessonInstance<ApiPersonalProfile, ApiLearningUnitTeacher>>(
      this.getUrlLessonTeacher(`/lessons/${lessonId}/classroom`, teacherId),
      {});
  }
}

